import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const styles = theme => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        padding: theme.spacing(0.5, 1),
    },
    loginButton: {
        borderRadius: 999,
        textTransform: 'none',
        fontWeight: 600,
        padding: theme.spacing(0.75, 2.25),
        borderColor: 'rgba(15, 23, 42, 0.25)',
        color: theme.palette.text.primary,
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': {
            borderColor: 'rgba(15, 23, 42, 0.45)',
            backgroundColor: 'rgba(15, 23, 42, 0.06)',
            transform: 'translateY(-1px)',
            boxShadow: '0 8px 18px rgba(15, 23, 42, 0.18)',
        },
    },
});

class LoginButton extends Component {

    handleLogin = () => {
        this.props.history.push(`/home`);
    }

    render() {

        const { classes } = this.props;

        return (
            <div style={{ backgroundColor: this.props.color }} className={classes.container}>
                {!this.props.user.first_name && (
                    <Button
                        onClick={this.handleLogin}
                        variant="outlined"
                        className={classes.loginButton}
                    >
                        Log in
                    </Button>
                )}
            </div>
        );

    }

}

const mapStateToProps = state => ({
    user: state.user,
});

export default withRouter(
    connect(mapStateToProps)(withStyles(styles)(LoginButton))
);
